import { Controller } from '@hotwired/stimulus'

// A <details> sitting at the bottom of a page unfolds below the fold on mobile:
// nothing visibly changes. Once open, bring the revealed content into view.
export default class extends Controller {
  // Un details rendu `open` par le serveur émet un toggle au chargement (parser) :
  // sans ce garde, la page scrolle d'elle-même vers les options à l'arrivée.
  connect() {
    this.skipInitialReveal = this.element.open
  }

  reveal() {
    if (!this.element.open) return
    if (this.skipInitialReveal) {
      this.skipInitialReveal = false
      return
    }

    const scroll = () => this.element.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    if (window.matchMedia('(min-width: 1024px)').matches) {
      // Desktop : après la transition de hauteur (0.3s, see details::details-content).
      setTimeout(scroll, 320)
    } else {
      // Mobile : le dépli est instantané (cf. application.css), scroll immédiat.
      requestAnimationFrame(scroll)
    }
  }
}
